//-- Copyright (c) 2021 TMT Insights Group, LLC
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '@/_utils/axios';
import { differenceBy } from 'lodash';
import { FileManagerInventoryFile, FileQueueState } from './slice_types';
import { RootState } from '@/redux/store';

const initialState: FileQueueState = {
  items: []
};

export const moveOrCopyFiles = createAsyncThunk('fileQueue/moveOrCopyFiles', async (action, thunkAPI) => {
  const { fileManager, fileQueue } = thunkAPI.getState() as RootState;
  const currentPath = fileManager.currentPath;
  const dst_slug = currentPath[0];
  const items = fileQueue.items;
  const url = `vfs/file_action/${action}/`;
  const path = currentPath.slice(1, currentPath.length).join('/');
  const dst_path = path === '/' ? '' : path;
  const validItems = items.filter(
    (item: FileManagerInventoryFile) => item.key.substring(0, item.key.lastIndexOf('/')) !== path || item.origin_slug !== dst_slug
  );
  const body = { files: items, dst_slug, dst_path };
  return axios
    .post(url, body)
    .then(() => ({ items: validItems, action }))
    .catch((err) => thunkAPI.rejectWithValue(err.response.data));
});

const fileQueueSlice = createSlice({
  name: 'fileQueue',
  initialState,
  reducers: {
    addToFileQueue: (state, { payload }) => {
      state.items.push(payload);
    },
    removeFromFileQueue: (state, { payload }) => {
      state.items = state.items.filter((file) => file.key !== payload.key);
    },
    addMultiToFileQueue: (state, { payload }) => {
      state.items = payload;
    },
    clearFileQueue: (state) => {
      state.items = [];
    }
  },
  extraReducers: (builder) => {
    builder.addCase(moveOrCopyFiles.fulfilled, (state, { payload: { items } }) => {
      state.items = differenceBy(state.items, items, 'key');
    });
  }
});

export const { addToFileQueue, removeFromFileQueue, clearFileQueue, addMultiToFileQueue } = fileQueueSlice.actions;

export default fileQueueSlice.reducer;
